import { useCallback, useState } from "react";

import {
  DEFAULT_VALUE,
  TYPEOF_UNDEFINED,
  WINDOW_EVENTS,
} from "../../../../constants";
import { useEventListener } from "../useEventListener/useEventListener";

const getWindowWidth = () =>
  typeof window !== TYPEOF_UNDEFINED ? window.innerWidth : DEFAULT_VALUE;

/**
 * Tracks window.innerWidth and updates on resize.
 * Prefer this over reading window.innerWidth during render.
 */
export const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(getWindowWidth);

  const handleResize = useCallback(() => {
    setWindowWidth(getWindowWidth());
  }, []);

  useEventListener(WINDOW_EVENTS.RESIZE, handleResize);

  return windowWidth;
};
